import React from "react";
import { useTranslation } from "react-i18next";
import { ItemModel } from "../../../../shared/game/ItemModel";
import { ItemEditorWindow } from "./windows/ItemEditorWindow";
import { Selector } from "./Selector";
import { parseFormattedTreeParameter } from "../../../../shared/helper/actionTreeHelper";
import { isBlank } from "../../../../shared/helper/generalHelpers";
import { gameStore } from "../../../stores/GameStore";
import { itemStore } from "../../../stores/ItemStore";
import { imageStore } from "../../../stores/ImageStore";
import { ItemImageMissingIcon, NoItemIcon } from "../../editor/ElementIcons";
export const ItemSelector = props => {
  const {
    t
  } = useTranslation();

  const filteredItemList = tagToFilter => {
    if (tagToFilter !== "") return itemStore.getItemsForTag(tagToFilter);
    const parameters = props.treeParameters.map(treeParameter => {
      const parameterItem = new ItemModel({
        id: treeParameter
      });
      parameterItem.name.set(gameStore.languageKey, treeParameter);
      return parameterItem;
    });
    return [...parameters, ...itemStore.getAllItems].sort(a => a.moduleOwner ? -1 : 1);
  };

  const prepareNewItem = () => {
    itemStore.setSelectedItem(null);
  };

  const buttonLabel = () => {
    if (parseFormattedTreeParameter(props.value)) return props.value;
    return itemStore.getItem(props.value) ? itemStore.getItem(props.value).name.get(gameStore.languageKey) : t("action_editor.no_item_set");
  };

  return /*#__PURE__*/React.createElement(Selector, {
    currentElement: itemStore.getItem(props.value),
    valueSetter: props.valueSetter,
    newString: "editor.item_new",
    filteredListGetter: filteredItemList,
    filterGetter: itemStore.getAllItemTags,
    getElementValue: item => item ? item.id : "",
    getElementImageUrl: item => item ? imageStore.getImageUrl(item.itemImageId) : null,
    getElementIcon: item => item ? /*#__PURE__*/React.createElement(ItemImageMissingIcon, null) : /*#__PURE__*/React.createElement(NoItemIcon, null),
    getElementName: item => item === null || item === void 0 ? void 0 : item.name.get(gameStore.languageKey),
    getElementIsOwnedByAModule: item => !!(item !== null && item !== void 0 && item.moduleOwner),
    prepareNewElement: prepareNewItem,
    buttonText: buttonLabel(),
    buttonInvalidProvider: () => !props.allowBlankValue && isBlank(props.value),
    beforeOpenEditorView: item => itemStore.setSelectedItem(item),
    editorView: (selectAndClose, closeEditor, selectorWidth) => /*#__PURE__*/React.createElement(ItemEditorWindow, {
      closeEditor: closeEditor,
      selectorWidth: selectorWidth
    })
  });
};